import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {SearchState, IntegratedFiltering} from '@devexpress/dx-react-grid';
import {Grid, Table, TableHeaderRow, SearchPanel, Toolbar} from '@devexpress/dx-react-grid-bootstrap4';
import { Card } from 'reactstrap';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as activityActions from './../../actions/activityActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as commonActions from './../../actions/commonActions';
import * as newsFeedActions from './../../actions/newsFeedActions';
import * as authActions from '../../redux/modules/auth';
import styles from './ActivityLogComponent.less';
import { setDirection } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
// const elementsData = [
//   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"card-header", "elementType":"tag", "applyTo":"alternative", "tagNames":"tr"},
//   {"classNames":"material-icons","elementType":"normal", "applyTo":"single", "tagNames":"i"},
//   {"classNames":"form-control","elementType":"normal", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"noDataColor", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dx-g-bs4-table-cell","elementType":"normal", "applyTo":"all", "tagNames":"td"},
//   {"classNames":"dx-g-bs4-table-container","elementType":"normal", "applyTo":"all", "tagNames":"div"}
// ];
const directionData=[
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"widgetbody", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbody", "elementType":"normal", "applyTo":"single", "tagNames":"div"}
];
@connect(
  state => ({modal: state.dashboardRoot.commonReducer.modal,
  notificationCount:0,
  layout: state.dashboardRoot.dashboardReducer.layout,
  clickedEdit: state.dashboardRoot.dashboardReducer.clickedEdit,
  activityLog:state.dashboardRoot.activityReducer.activityLog,
  newsFeedData: state.dashboardRoot.commonReducer.newsFeedData,
  userDetail: state.auth.userDetail,
  actLogRandomNo:state.dashboardRoot.activityReducer.actLogRandomNo,
  //selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  fontSize: state.auth.userDetail.fontSize,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language
}),
  {...activityActions,...newsFeedActions,...dashboardActions,...commonActions,...authActions})

export default class ActivityLogComponent extends Component {

  static propTypes = {
    /* socketData: PropTypes.array,*/
    CloseIcon:PropTypes.object,
    //keyValue:PropTypes.string.isRequired,
    deleteWidget:PropTypes.func,
    showPreview:PropTypes.object,
    clickedEdit:PropTypes.bool,
    popoutIcon:PropTypes.object,
    activityLog:PropTypes.array,
    notificationCount:PropTypes.number,
    loadNewsFeedComponent:PropTypes.func,
    newsFeedData:PropTypes.array,
    popupwindowHandle:PropTypes.func,
    openedWidgets:PropTypes.array,
    popinWidget:PropTypes.func,
    userDetail:PropTypes.object,
    actLogRandomNo:PropTypes.number
  };

  state = {
    clickedRemove:false,
    ifClosed:true,
    clickedPopup:false,
    iconVisible:false,
    isPopOutDisabled:false,
    activityLogcols: [
      {name:'det', title:' ', align:'left'},
      {name:'docNo', title:' ', align:'left'},
      {name:'remark', title:' ', align:'left'}
    ],
    searchValue:'',
    activityLogRows:[],
    activityColumnExtensions:[
      {columnName:'det', width:180},
      {columnName:'deal', width:100}
    ],
    randomNo:0
  }

  constructor() {
    super();
    window.changePopoutState = this.changePopoutState.bind(this);
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
  }

  componentDidMount(){
    const thisComponent = ReactDOM.findDOMNode(this);
    setDirection(ReactDOM.findDOMNode(this), directionData, this.props.selectedLang);
    this.setState({activityLogRows:this.props.activityLog });
  }

  componentWillReceiveProps(nextProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = nextProps.selectedCssColorTheme;

    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this), directionData, nextProps.selectedLang);
    }
    if(nextProps.checkClickOnAddWidgetFlag !== false){
    //  applyStyle(thisComponent, allCssStyleRules, elementsData);
    }
    if(nextProps.actLogRandomNo !== this.state.randomNo){
      if(this.state.activityLogRows.length != nextProps.activityLog.length){
          var activityLog = [];
          var obj=nextProps.activityLog;
          this.setState({activityLogRows:activityLog.concat(obj)});
          this.setState({randomNo:nextProps.actLogRandomNo})
      }
    }
  }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue:value });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"ActivityLogComponent"});
   }
  }

  changePopoutState = () =>{
    try{
      this.setState({isPopOutDisabled:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changePopoutState', component:"ActivityLogComponent"});
    }
  }

  render() {
    const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
    const searchPlaceholderMsg = {
      searchPlaceholder: (i18next.t('search'))+'...',
    };
    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
        //  backgroundColor:this.props.selectedCssColorTheme.listRow.background,
        //  color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
         // backgroundColor:this.props.selectedCssColorTheme.listRowNext.background,
         // color:this.props.selectedCssColorTheme.listRow.color
        }
      },
    });

    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} id="actLogTable" className={classes.tableStriped} />
    );
    var NoDataMsg = {
      noData: '',
    }
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = '';
    } else {
      NoDataMsg.noData = i18next.t('noDataAvlMsg');
    }
    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell"  />
    );
    //
//style={this.props.selectedCssColorTheme.trdbkWidget
    return (
      <div className={styles.widgetwrapper}>
        <div className={`${styles.trdhead} ${selectedfont_size}`}>
          <div className={`${styles.widgetbody} ${selectedfont_size} ${this.props.language} trdbody`}>
            <div className={`${styles.tablebordered} table`} id="activitycomptbl">
              <Card>
                <Grid style={{ height: '100%' }} rows={this.state.activityLogRows}  columns={this.state.activityLogcols}>
                  <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                  <IntegratedFiltering />
                  <Table tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)} columnAutoWidth={true}  height="auto" columnExtensions={this.state.activityColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                  <TableHeaderRow />
                  <Toolbar />
                  <SearchPanel messages={searchPlaceholderMsg} />
                </Grid>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
